const STORAGE_KEY = 'saved-credentials'

interface RestaurantCredentials {
  type: 'restaurant'
  restaurantId: number
  accessKey: string
}

export type SavedCredentials = RestaurantCredentials

export function saveCredentials(credentials: SavedCredentials): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(credentials))
  } catch {
    // Storage full or unavailable
  }
}

export function loadCredentials(): SavedCredentials | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as Partial<SavedCredentials> & { type?: unknown }
    if (
      parsed.type === 'restaurant' &&
      typeof parsed.restaurantId === 'number' &&
      Number.isInteger(parsed.restaurantId) &&
      typeof parsed.accessKey === 'string'
    ) {
      return parsed as SavedCredentials
    }

    // Migrate away old admin-password entries and discard malformed values.
    // Admin credentials must never be persisted or silently replayed.
    localStorage.removeItem(STORAGE_KEY)
    return null
  } catch {
    return null
  }
}

/**
 * Build a Basic Auth header value from stored restaurant credentials.
 * Returns null when no restaurant credentials are stored.
 */
export function getBasicAuthHeader(): string | null {
  const creds = loadCredentials()
  if (creds?.type !== 'restaurant') return null
  return 'Basic ' + btoa(`${creds.restaurantId}:${creds.accessKey}`)
}

export function clearCredentials(): void {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch {
    // Ignore
  }
}
